export default "__VITE_ASSET__BX20SJEF__"